import { SpecialEventCalendarEntryPeriod, SpecialEventCalendarReferencePeriod } from '../../../services/schedulers/types';
import { TAutomationApp } from '../../types'


export const schema = 'AutomationApps.Functions.Schedules.Scheduler';


export type TScheduler = {
    weekleySchedule: string,
    exeptionSchedule: string,
    currentStateText: string | undefined,
    value: number | null
    dateFrom: string | null | undefined,
    dateTo: string | null | undefined,
    dataType: string,
    isOn: boolean,
    stateTextList: string | undefined,
    defaultValue: number | null
    timeZone: string
} & TAutomationApp

//view model types
export type TDailyScheduleEntry = {
    weekday: number,
    id: string,
    start: Date,
    end: Date,
    value: number | boolean | undefined | null
    isDefault: boolean
}

export type TDailySchedule = {
    weekday: number,
    entries: TDailyScheduleEntry[]
} 

export type TSpecialEvent = {
    eventPriority: number,
    entries: TDailyScheduleEntry[],
    calendarReference?: SpecialEventCalendarReferencePeriod | undefined,
    calendarEntry?: SpecialEventCalendarEntryPeriod | undefined,
}